<template>
  <v-app :class="{ 'env-live': isLive, 'env-dev': !isLive }">
    <!-- 헤더 -->
    <v-app-bar app :color="isLive ? '#37474F' : '#1565C0'" dark clipped-left flat dense class="cms-appbar">
      <v-app-bar-nav-icon class="d-md-none" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <div class="d-flex align-center">
        <v-icon class="mr-2" size="22">mdi-monitor-dashboard</v-icon>
        <span class="cms-appbar__title">{{getDisplayText}}</span>
      </div>
      <v-spacer></v-spacer>
      <v-chip v-if="user_id" small outlined dark class="mr-2 d-none d-sm-flex">
        <v-icon left small>mdi-account</v-icon>
        {{ user_id }}
      </v-chip>
      <v-btn icon small dark @click="logout" title="로그아웃">
        <v-icon small>mdi-logout</v-icon>
      </v-btn>
    </v-app-bar>

    <!-- 사이드바 -->
    <v-navigation-drawer
      app clipped
      v-model="drawer"
      :permanent="$vuetify.breakpoint.mdAndUp"
      :temporary="$vuetify.breakpoint.smAndDown"
      :width="$vuetify.breakpoint.smAndDown ? 260 : 250"
      :mini-variant="false"
      class="cms-sidebar"
    >
      <!-- 유저 프로필 영역 -->
      <div class="cms-sidebar__profile" v-if="user_id">
        <v-avatar :color="isLive ? 'deep-purple accent-4' : 'blue darken-2'" size="36" class="mr-3">
          <span class="white--text font-weight-bold" style="font-size: 14px;">{{ user_id.charAt(0).toUpperCase() }}</span>
        </v-avatar>
        <div class="cms-sidebar__profile-info">
          <div class="cms-sidebar__profile-name">{{ user_id }}</div>
          <div class="cms-sidebar__profile-env">
            <v-chip x-small :color="isLive ? 'red' : 'blue'" dark label>{{ isLive ? 'LIVE' : 'DEV' }}</v-chip>
          </div>
        </div>
      </div>
      <div class="cms-sidebar__profile" v-else>
        <v-icon class="mr-2" color="grey">mdi-account-off</v-icon>
        <span class="grey--text text-body-2">로그인 해주세요</span>
      </div>

      <v-divider></v-divider>

      <!-- 메뉴 리스트 -->
      <v-list dense nav class="cms-sidebar__menu">
        <template v-for="(item, index_group) in itemContainer">
        <div v-if="item.type === 'divider'" :key="index_group + '_div'" class="cms-sidebar__divider">
          <v-divider class="my-1"></v-divider>
          <div class="cms-sidebar__divider-label">{{ item.title }}</div>
          <v-divider class="my-1"></v-divider>
        </div>
        <v-list-group
          v-else
          :key="index_group + '_index'"
          v-model="item.active"
          :prepend-icon="item.action"
          no-action
          color="primary"
          class="cms-sidebar__group"
        >
          <!-- 셀렉트 영역 (게임/서버/OS/언어) -->
          <div v-if="item.type=='game'" class="cms-sidebar__select-wrap">
            <v-select
              v-model="selected_game"
              :items="game_titles"
              item-text="name"
              item-value="value"
              label="게임 선택"
              @change="changeRoute()"
              dense outlined hide-details
              class="cms-sidebar__select"
            ></v-select>
          </div>
          <div v-if="game_servers.length > 1" class="cms-sidebar__select-wrap">
            <v-select
              v-model="selected_server"
              :items="game_servers"
              item-text="name"
              item-value="value"
              label="서버 선택"
              @change="changeRoute()"
              dense outlined hide-details
              class="cms-sidebar__select"
            ></v-select>
          </div>
          <div v-if="item.type=='advertisement'" class="cms-sidebar__select-wrap">
            <v-select
              v-model="selected_os"
              :items="oses"
              item-text="name"
              item-value="value"
              label="OS 선택"
              @change="changeRoute()"
              dense outlined hide-details
              class="cms-sidebar__select"
            ></v-select>
          </div>
          <div v-if="item.type=='advertisement'" class="cms-sidebar__select-wrap">
            <v-select
              v-model="selected_language"
              :items="languages"
              item-text="name"
              item-value="value"
              label="언어 선택"
              @change="changeRoute()"
              dense outlined hide-details
              class="cms-sidebar__select"
            ></v-select>
          </div>

          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title class="cms-sidebar__group-title">
                {{ item.title }}
                <span v-if="hasTitleDot(item.type)" class="review-red-dot" title="미처리 항목 누적"></span>
              </v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="(child, index_child) in item.items.filter(c => !c.dev_only || !isLive)"
            :key="index_child+'index_child'"
            :to="child.path"
            class="cms-sidebar__item"
            active-class="cms-sidebar__item--active"
          >
            <v-list-item-icon class="cms-sidebar__item-icon">
              <v-icon small>{{ child.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="cms-sidebar__item-title">
                {{ child.title }}
                <span v-if="isDotChild(child.path) && hasSubDot(child.path)" class="review-red-dot" title="미처리 항목 있음"></span>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        </template>
      </v-list>
    </v-navigation-drawer>

    <!-- 메인 컨텐츠 -->
    <v-content fluid class="cms-content">
      <router-view :key="$route.fullPath"></router-view>
    </v-content>
  </v-app>
</template>

<script>
import { mapState } from 'vuex';
import { mapActions } from 'vuex';
import store from './store';
// import HelloWorld from './components/HelloWorld';

// prism-qa-cms.day7games.com
import config from '../src/config/config'

export default {
  name: 'App',

  components: {
    //HelloWorld,
  },
  methods: {
    ...mapActions([
        // 'GET_SERVERS',        
    ]),
    logout() {
      store.commit('LOGOUT');
      this.$router.push('/login');
    },
    refreshMenu(){
            console.log("WHAT IS THIS 222? " + this.$store.state.user_level)
            this.itemContainer = [];
            

            if(this.$store.state.user_level >= 999)
            {
              this.itemContainer.push(this.dashboardContainer);
              this.itemContainer.push(this.HouseAdMenuContainer);
              this.itemContainer.push(this.defaultMenuContainer);
              // this.itemContainer.push(this.dantaMenuContainer);   // 단타의 신 — 미사용, 메뉴에서 제외
              this.itemContainer.push(this.quizncashMenuContainer);
              this.itemContainer.push(this.cpuMenuContainer);              
            }
            if(this.$store.state.user_level >= 999 ||  this.$store.state.user_level == 101){// 금털기 회사
              this.itemContainer.push(this.carrygoldMenuContainer);
              this.itemContainer.push(this.pntFactoryMenuContainer);
              this.itemContainer.push(this.mandooraMenuContainer);   // [돈만농] 포인트공장 바로 아래
            }


            // [프롬북] — 항상 노출 (user_level 999 권한자에게)
            if (this.$store.state.user_level >= 999  ||  this.$store.state.user_level == 102) { //서머 외주 
              // 개발 서버(localhost) 에서만 [API 테스터] 메뉴 항목 추가
                const items = this.promptMasterMenuContainer.items;
                const exists = items.some(it => it.path === '/prombook/api_tester');
                if (!exists) {
                  items.push({ path: '/prombook/api_tester', title: 'API 테스터 (DEV)', icon: 'mdi-flask-outline' });
                }
              // this.itemContainer.push(this.promptMasterMenuContainer);   // [프롬북] 메뉴 숨김 (라우트는 유지 — 주소로 직접 접근은 가능)
            }

            if( this.$store.state.user_level == 103){
                 this.itemContainer.push(this.defaultMenuContainer);
            }

            this.itemContainer.push({ type: 'divider', title: '... SNAPPLAY ...' });
         
             this.itemContainer.push({ type: 'divider', title: '... SERVICE ...' });
            //this.itemContainer.push(this.HouseAdMenuContainer);
            //this.itemContainer.push(this.BillingContainer);
    },
    // ── 메뉴 레드닷 ──
    // 그룹 타이틀 레드닷: 그 그룹 소스 중 하나라도 titleThreshold 이상이면 ON
    hasTitleDot(type) {
      return this.dotSources.some(s => s.type === type && (this.dotCounts[s.key] || 0) >= s.titleThreshold);
    },
    // 자식 메뉴 항목 레드닷: 해당 경로 소스가 subThreshold 이상이면 ON
    hasSubDot(path) {
      const s = this.dotSources.find(s => s.childPath === path);
      return !!s && (this.dotCounts[s.key] || 0) >= s.subThreshold;
    },
    // 이 자식 항목에 레드닷 소스가 붙어있는지
    isDotChild(path) {
      return this.dotSources.some(s => s.childPath === path);
    },
    // 게임별 미처리 건수 조회 (권한 없는 게임은 실패해도 무시 → 0)
    async loadReviewCounts() {
      // 캐시 먼저 반영해 즉시 표기 (새 조회 완료 시 갱신)
      try {
        const cached = JSON.parse(localStorage.getItem('menu_dot_counts_v2'));
        if (cached && typeof cached === 'object') this.dotCounts = { ...cached };
      } catch (e) { /* ignore */ }

      const next = {};
      await Promise.all(this.dotSources.map(async (s) => {
        try {
          const res = await this.$store.dispatch(s.action, s.payload);
          const data = (res && res.response_data) ? res.response_data : res;
          let list = (data && data[s.listKey]) || [];
          if (!Array.isArray(list)) list = [];
          if (s.pendingField) {
            // 상태값 목록에서 '대기'만 카운트 (예: 금교환 PROCESS_STATE ∈ ['', 'WAIT'])
            next[s.key] = list.filter(x => s.pendingValues.includes((x && x[s.pendingField]) || '')).length;
          } else {
            next[s.key] = list.length;
          }
        } catch (e) {
          next[s.key] = 0;   // 권한 없음/에러 → 레드닷 없음
        }
      }));

      this.dotCounts = next;
      try { localStorage.setItem('menu_dot_counts_v2', JSON.stringify(next)); } catch (e) { /* ignore */ }
    },

    changeRoute() {
        //store.state.selected_game_package = this.selected_game;
        store.state.selected_ad_os = this.selected_os;
        store.state.selected_ad_language = this.selected_language;
        store.state.selected_game_server = this.selected_server;
        
    },
  },
  computed: {
    ...mapState({
      user_id: 'user_id'
    }),
    isQa() {
      return config.isQa;
    },
    isLive() {
      return config.isLive;
    },
    isQaGlobal() {
      return config.isQaGlobal;
    },
    getDisplayText()
    {
      return `${config.getDisplayText.toUpperCase()}`;
    }
  },
//대시보드 --> 접속자수 , 
//
  // 메일 관리 
  //{ path: '/game_template', title: '테이블 관리', icon: 'mdi-text-box-multiple' },
  // { path: '/user_info', title: '샘플 유저정보', icon: 'mdi-cog' },
  data: () => ({
      drawer: null,
      dashboardContainer:{
        type:'dashboard',
        title:'[대시 보드]', 
        action:'mdi-comment-question-outline',
        items:[
        { path: '/dashboard', title: '대시보드(개발중)', icon: 'mdi-account-details-outline' },
        { path: '/image_uploader_util', title: '이미지 업로더 유틸', icon: 'mdi-image-multiple' },
        // { path: '/game_mail', title: '우편 전송', icon: 'mdi-email-multiple-outline' },
        // { path: '/game_notice', title: '[통합] 공지', icon: 'mdi-alert-decagram' },        
        // { path: '/game_coupon', title: '퀴스 ', icon: 'mdi-ticket-percent' },        
        // { path: '/game_setting', title: '[통합] 서버 설정', icon: 'mdi-cog' },
        ]
      },
      defaultMenuContainer:{
        type:'snapquiz',
        title:'[스냅 퀴즈]', 
        action:'mdi-comment-question-outline',
        items:[
        { path: '/quiz_dash_board', title: '대시보드', icon: 'mdi-view-dashboard-outline' },
        { path: '/quizlist', title: '이미지 퀴즈', icon: 'mdi-image' },
        { path: '/quizlist_adbundle', title: '이미지 퀴즈(광고번들)', icon: 'mdi-image-multiple' },
        // { path: '/img_quiz_log', title: '이미지 퀴즈 통계', icon: 'mdi-account-multiple-outline' },
        { path: '/img_quiz_log_visit', title: '퀴즈 오가닉 방문통계', icon: 'mdi-account-multiple-outline' },

        { path: '/testlist', title: '심리 테스트', icon: 'mdi-book-open-page-variant' },
        { path: '/partner', title: '퀴즈 파트너', icon: 'mdi-account-multiple-outline' },
        { path: '/quizlist_group', title: '퀴즈그룹 관리 (PUB)', icon: 'mdi-account-multiple-outline' },

        { path: '/quiz_notice', title: '퀴즈 공지사항', icon: 'mdi-book-open-page-variant' },
        { path: '/quiz_reward_ad', title: '보상형 하우스애드', icon: 'mdi-gift-outline' },
        { path: '/quiz_uploader', title: '퀴즈업로더', icon: 'mdi-upload-box' },
        { path: '/quiz_setting', title: '서버 설정', icon: 'mdi-cog' },
        
        // { path: '/game_mail', title: '우편 전송', icon: 'mdi-email-multiple-outline' },
        // { path: '/game_notice', title: '[통합] 공지', icon: 'mdi-alert-decagram' },        
        // { path: '/game_coupon', title: '퀴스 ', icon: 'mdi-ticket-percent' },        
        // { path: '/game_setting', title: '[통합] 서버 설정', icon: 'mdi-cog' },
        ]
      },
      cpuMenuContainer:{
        type:'cpu',
        title:'[포인트 채굴기]',
        action:'mdi-gamepad-variant-outline',
        items:[
        { path: '/cpu_dash_board', title: '대시보드', icon: 'mdi-account-details-outline' },
        { path: '/cpu_user_list', title: '유저 데이터 관리', icon: 'mdi-account-details-outline' },
        { path: '/cpu_mail', title: '우편 전송 이벤트', icon: 'mdi-email-multiple-outline' },
        { path: '/cpu_coupon', title: '쿠폰 발급 관리', icon: 'mdi-ticket-percent' },        
        { path: '/cpu_notice', title: '공지사항', icon: 'mdi-alert-decagram' },          
        { path: '/cpu_exchange', title: '교환소', icon: 'mdi-swap-horizontal' },
        { path: '/cpu_game_yt_event_manage', title: '유투브 이벤트 관리', icon: 'mdi-youtube' },       
        { path: '/cpu_event_noti', title: '전면 이벤트 관리', icon: 'mdi-bullhorn' },
        { path: '/cpu_event_rolling', title: '이벤트 롤링 관리', icon: 'mdi-calendar-clock' },
        { path: '/cpu_event_verify', title: '유저 이벤트 검수', icon: 'mdi-checkbox-marked-circle-outline' },

        { path: '/cpu_token_content', title: '토큰 컨텐츠', icon: 'mdi-treasure-chest' },
        { path: '/cpu_setting', title: '서버 설정', icon: 'mdi-cog' },
        { path: '/cpu/api_tester', title: 'API 테스터', icon: 'mdi-flask-outline' },
        //{ path: '/cpu_template', title: '[통합] 테이블', icon: 'mdi-file-table-outline' },
        //{ path: '/errorlog_list', title: '에러로그 리스트', icon: 'mdi-cog' },        
        //{ path: '/game_chat', title: '채팅관리', icon: 'mdi-file-table-outline' },                
        //{ path: '/db_selecter', title: '데이터베이스 조회', icon: 'mdi-database' },
        ]
      },
        quizncashMenuContainer:{
        type:'quizcash',
        title:'[퀴즈N캐시 APP]', 
        action:'mdi-lightbulb-question-outline',
        items:[
        { path: '/quizcash_dash_board', title: '대시보드', icon: 'mdi-account-details-outline' },
        { path: '/quizcash_main_quiz_info', title: '메인 퀴즈 정보', icon: 'mdi-help-circle' },
        { path: '/quizcash_user_list', title: '유저 데이터 관리', icon: 'mdi-account-details-outline' },
        { path: '/quizcash_mail', title: '우편 전송 이벤트', icon: 'mdi-email-multiple-outline' },
        { path: '/quizcash_coupon', title: '쿠폰 발급 관리', icon: 'mdi-ticket-percent' },        
        { path: '/quizcash_notice', title: '공지사항', icon: 'mdi-alert-decagram' },          
        { path: '/quizcash_coin_product', title: '코인/현금 상품관리', icon: 'mdi-atom' }, 
        //{ path: '/quizcash_coin_order_list', title: '코인 주문관리', icon: 'mdi-file-document-multiple-outline' },       
        { path: '/quizcash_cash_order_list', title: '현금 주문관리', icon: 'mdi-currency-krw' },       
        { path: '/quizcash_user_buy_products', title: '유저상품 구매내역', icon: 'mdi-file-document-multiple-outline' },       
        { path: '/quizcash_game_yt_event_manage', title: '유투브 이벤트 관리', icon: 'mdi-youtube' },       
        { path: '/quizcash_event_rolling', title: '이벤트 롤링 관리', icon: 'mdi-calendar-clock' },
        { path: '/quizcash_event_verify', title: '유저 이벤트 검수', icon: 'mdi-checkbox-marked-circle-outline' },
        
        { path: '/quizcash_setting', title: '서버 설정', icon: 'mdi-cog' },
        // 라이브 서버 대상 테스트가 목적이라 dev_only 를 붙이지 않는다(운영에서도 노출)
        { path: '/quizcash/api_tester', title: 'API 테스터', icon: 'mdi-flask-outline' },
        //{ path: '/cpu_template', title: '[통합] 테이블', icon: 'mdi-file-table-outline' },                        
        //{ path: '/errorlog_list', title: '에러로그 리스트', icon: 'mdi-cog' },        
        //{ path: '/game_chat', title: '채팅관리', icon: 'mdi-file-table-outline' },                
        //{ path: '/db_selecter', title: '데이터베이스 조회', icon: 'mdi-database' },
        ]
      },
      pntFactoryMenuContainer:{
        type:'pnt_factory',
        title:'[포인트공장]',
        action:'mdi-diamond-stone',
        items:[
          { path: '/pnt_factory/dashboard',         title: '대시보드',          icon: 'mdi-view-dashboard' },
          { path: '/pnt_factory/user_list',         title: '유저 데이터 관리',  icon: 'mdi-account-details-outline' },
          { path: '/pnt_factory/mail',              title: '우편 전송',          icon: 'mdi-email-multiple-outline' },
          { path: '/pnt_factory/coupon',            title: '쿠폰 발급 관리',    icon: 'mdi-ticket-percent' },
          { path: '/pnt_factory/notice',            title: '공지사항',           icon: 'mdi-alert-decagram' },
          { path: '/pnt_factory/cash_product',      title: '현금 상품 관리',    icon: 'mdi-atom' },
          { path: '/pnt_factory/cash_order',        title: '현금 주문 관리',    icon: 'mdi-currency-krw' },
          { path: '/pnt_factory/user_buy_products', title: '유저 상품 구매내역', icon: 'mdi-file-document-multiple-outline' },
          { path: '/pnt_factory/event_noti',        title: '전면 이벤트 관리',  icon: 'mdi-bullhorn' },
          { path: '/pnt_factory/setting',           title: '서버 설정',          icon: 'mdi-cog' },
          { path: '/pnt_factory/dev_util',          title: '개발 유틸리티',      icon: 'mdi-tools' },
          { path: '/pnt_factory/api_tester',        title: 'API 테스터',         icon: 'mdi-flask-outline', dev_only: true },
        ]
      },
      mandooraMenuContainer:{
        type:'mandoora',
        title:'[돈만농]',
        action:'mdi-sprout',
        items:[
          { path: '/mandoora/dashboard',         title: '대시보드',          icon: 'mdi-view-dashboard' },
          { path: '/mandoora/user_list',         title: '유저 데이터 관리',  icon: 'mdi-account-details-outline' },
          { path: '/mandoora/mail',              title: '우편 전송',          icon: 'mdi-email-multiple-outline' },
          { path: '/mandoora/coupon',            title: '쿠폰 발급 관리',    icon: 'mdi-ticket-percent' },
          { path: '/mandoora/notice',            title: '공지사항',           icon: 'mdi-alert-decagram' },
          { path: '/mandoora/cash_product',      title: '현금 상품 관리',    icon: 'mdi-atom' },
          { path: '/mandoora/cash_order',        title: '현금 주문 관리',    icon: 'mdi-currency-krw' },
          { path: '/mandoora/user_buy_products', title: '유저 상품 구매내역', icon: 'mdi-file-document-multiple-outline' },
          { path: '/mandoora/event_noti',        title: '전면 이벤트 관리',  icon: 'mdi-bullhorn' },
          { path: '/mandoora/setting',           title: '서버 설정',          icon: 'mdi-cog' },
          { path: '/mandoora/dev_util',          title: '개발 유틸리티',      icon: 'mdi-tools' },
          { path: '/mandoora/api_tester',        title: 'API 테스터',         icon: 'mdi-flask-outline', dev_only: true },
        ]
      },
      carrygoldMenuContainer:{
        type:'carrygold',
        title:'[금털기]',
        action:'mdi-gold',
        items:[
        { path: '/carrygold_dash_board', title: '대시보드', icon: 'mdi-view-dashboard' },
        { path: '/carrygold_user_list', title: '유저 데이터 관리', icon: 'mdi-account-details-outline' },
        { path: '/carrygold_mail', title: '우편 전송 이벤트', icon: 'mdi-email-multiple-outline' },
        { path: '/carrygold_coupon', title: '쿠폰 발급 관리', icon: 'mdi-ticket-percent' },        
        { path: '/carrygold_notice', title: '공지사항', icon: 'mdi-alert-decagram' },          
        // { path: '/carrygold_coin_product', title: '현금 상품관리', icon: 'mdi-atom' },   // 금교환 관리 > 상품관리 탭으로 이동 (메뉴 숨김)
        // { path: '/carrygold_cash_order_list', title: '현금 주문관리', icon: 'mdi-currency-krw' },   // 메뉴 숨김
        { path: '/carrygold_gold_exchange', title: '금교환 관리', icon: 'mdi-gold' },       
        { path: '/carrygold_user_buy_products', title: '유저상품 구매내역', icon: 'mdi-file-document-multiple-outline' },       
        { path: '/carrygold_game_yt_event_manage', title: '유투브 이벤트 관리', icon: 'mdi-youtube' },
        { path: '/carrygold_event_noti', title: '전면 이벤트 관리', icon: 'mdi-bullhorn' },       
        { path: '/carrygold_notice_goldverify', title: '유저 이벤트 검수', icon: 'mdi-checkbox-marked-circle-outline' },
        { path: '/carrygold_auth_recover', title: '애플 계정복구(CS)', icon: 'mdi-account-key' },
        // { path: '/carrygold_chat_manage', title: '채팅 관리', icon: 'mdi-chat-processing-outline' },   // 미사용 — 메뉴 숨김
        { path: '/carrygold_dev_util', title: '개발 유틸리티', icon: 'mdi-tools' },
        // 라이브 서버 대상 테스트가 목적이라 dev_only 를 붙이지 않는다(운영에서도 노출)
        { path: '/carrygold/api_tester', title: 'API 테스터', icon: 'mdi-flask-outline' },
        // { path: '/carrygold_roulette_event', title: '금몰빵 룰렛 이벤트', icon: 'mdi-slot-machine' },   // 미사용 — 메뉴 숨김
        { path: '/carrygold_setting', title: '서버 설정', icon: 'mdi-cog' },
        //{ path: '/cpu_template', title: '[통합] 테이블', icon: 'mdi-file-table-outline' },                        
        //{ path: '/errorlog_list', title: '에러로그 리스트', icon: 'mdi-cog' },        
        //{ path: '/game_chat', title: '채팅관리', icon: 'mdi-file-table-outline' },                
        //{ path: '/db_selecter', title: '데이터베이스 조회', icon: 'mdi-database' },
        ]
      },
      dantaMenuContainer:{
        type:'danta',
        title:'[단타의 신]',
        action:'mdi-chart-line-variant',
        items:[
        { path: '/danta_dash_board', title: '대시보드', icon: 'mdi-view-dashboard' },
        { path: '/danta_callback_monitor', title: '콜백 모니터링', icon: 'mdi-webhook' },
        { path: '/danta_client_list', title: '고객사', icon: 'mdi-domain' },
        { path: '/danta_media_manage', title: '매체 관리', icon: 'mdi-television' },
        { path: '/danta_in_progress', title: '게임관리', icon: 'mdi-gamepad-variant' },
        // { path: '/danta_manual_round_manage', title: '수동 운영 라운드', icon: 'mdi-clipboard-edit-outline' },  // 운영 안정화까지 임시 숨김
        { path: '/danta_user_list', title: '유저 관리', icon: 'mdi-account-details-outline' },
        { path: '/danta_setting', title: '설정', icon: 'mdi-cog' },
        { path: '/danta_debug_test', title: '디버그 테스트', icon: 'mdi-bug-outline' },
        { path: '/danta_stats',      title: '통계 / 정산',   icon: 'mdi-chart-line-variant' },
        ]
      },
      promptMasterMenuContainer:{
        type:'prompt_master',
        title:'[프롬북]',
        action:'mdi-comment-text-multiple-outline',
        items:[
          { path: '/prombook/prompt/list', title: '프롬프트 관리',     icon: 'mdi-format-list-bulleted' },
          { path: '/prombook/feed/list',   title: '피드 관리',         icon: 'mdi-newspaper-variant-multiple-outline' },
          { path: '/prombook/user/list',   title: '유저 데이터 관리',  icon: 'mdi-account-details-outline' },
          { path: '/prombook/notice/list', title: '공지사항 관리',     icon: 'mdi-bullhorn-outline' },
          { path: '/prombook/event/list',  title: '전면 이벤트 관리',  icon: 'mdi-image-multiple-outline' },
          { path: '/prombook/buy_history', title: '유저상품 구매내역', icon: 'mdi-cart-outline' },
          { path: '/prombook/mail',        title: '우편 전송',         icon: 'mdi-email-multiple-outline' },
          { path: '/prombook/setting',     title: '서버 설정',         icon: 'mdi-cog' },
          // 개발 서버 (localhost) 에서만 노출 — 메뉴 push 시점에 isLocal 체크해서 추가
        ]
      },
      HouseAdMenuContainer: {
        type: 'housead',
        title: '[프로젝트 관리]',
        action: 'mdi-folder-cog-outline',
        items: [
          // { path: '/advertisement_house', title: '광고 리스트·통계', icon: 'mdi-view-dashboard' }, // 당분간 미사용
          { path: '/advertisement_house_app_list', title: '앱관리', icon: 'mdi-cellphone-link' },
          // 광고 관리 / 보상 관리 / 참여 정보는 이 화면 안에서 탭으로 접근한다
          { path: '/advertisement_house_ad_manage', title: '하우스애드', icon: 'mdi-advertisements' },
          // 쿠폰 상품/카테고리/노출설정/주문매출을 탭으로 통합한 단일 진입점
          { path: '/store', title: '스토어', icon: 'mdi-storefront-outline' },
          { path: '/phone_auth', title: '전화번호 인증', icon: 'mdi-cellphone-message' },
        ]
      },
      AdMenuContainer: {
        type:'advertisement',
        title:' 광고 [AD]', 
        action:'mdi-advertisements',
        items:[
        { path: '/advertisement_list', title: '광고 리스트', icon: 'mdi-format-list-bulleted' },
        { path: '/advertisement_regist', title: '광고 등록 및 수정', icon: 'mdi-file-document-edit-outline' },
        { path: '/advertisement_statistics', title: '광고 통계관리', icon: 'mdi-chart-pie' },
        ]
    },

      BillingContainer: {
        type:'billing',
        title:' 결제 [Billing]', 
        action:'mdi-credit-card-outline',
        items:[
        { path: '/billing_dash', title: '대시보드', icon: 'mdi-monitor-dashboard' },
        { path: '/billing_project', title: '프로젝트', icon: 'mdi-view-list' },
        { path: '/billing_statistics', title: '통계', icon: 'mdi-chart-line' },
        ]},
    itemContainer:[
   
    ],   
    game_titles : [{name:'싸울아비 키우기',value:'com.mad.pj.godfather'}],
    game_servers : [{name:'제 1 서버', value : 1}],
    oses : [{name:'Android',value:'Android'},{name:'IOS',value:'IOS'}],
    languages : [{name:'한국어',value:'KO'},{name:'영어',value:'EN'},{name:'중국어(간체)',value:'ZH-CHS'},{name:'중국어(번체)',value:'ZH-CHT'},{name:'일본어',value:'JA'}],
    selected_game:'com.mad.pj.godfather',
    selected_os:'Android',
    selected_language:'KO',
    selected_server:1,

    // ── 메뉴 레드닷 (미처리 건수 알림) ──
    // 앱 진입/처리 후 게임별 미처리 건수를 조회해 임계값 이상이면 메뉴에 레드닷.
    //   titleThreshold : 그룹 타이틀에 레드닷 (그 그룹의 소스 중 하나라도 충족하면 ON)
    //   subThreshold   : 해당 자식 메뉴 항목에 레드닷
    //   pendingField/pendingValues : 목록이 상태값을 가진 경우(금교환 등) 그 값만 카운트
    dotCounts: {},   // { [source.key]: count }
    dotSources: [
      // 미검수 리뷰 (미인증 N/W)
      { key: 'cpu_review',       type: 'cpu',       childPath: '/cpu_event_verify',            action: 'CPU_GET_REVIEW_LIST_NOT_VERIFY',       payload: { review_type: 'ALL' }, listKey: 'review_list', titleThreshold: 10, subThreshold: 1 },
      { key: 'carrygold_review', type: 'carrygold', childPath: '/carrygold_notice_goldverify', action: 'CARRYGOLD_GET_NOTICE_LIST_NOT_VERIFY', payload: { review_type: 'ALL' }, listKey: 'notice_list', titleThreshold: 10, subThreshold: 1 },
      { key: 'quizcash_review',  type: 'quizcash',  childPath: '/quizcash_event_verify',       action: 'QUIZNCASH_GET_REVIEW_LIST_NOT_VERIFY', payload: { review_type: 'ALL' }, listKey: 'review_list', titleThreshold: 5,  subThreshold: 1 },
      // 금털기 금교환 관리 (대기중 = PROCESS_STATE 가 'WAIT' 또는 빈값)
      { key: 'carrygold_gold',   type: 'carrygold', childPath: '/carrygold_gold_order_list',   action: 'CARRYGOLD_GET_GOLD_ORDER_LIST',        payload: { count: 200 }, listKey: 'order_list', pendingField: 'PROCESS_STATE', pendingValues: ['', 'WAIT'], titleThreshold: 3, subThreshold: 1 },
    ]
  }),
  created() 
  {    
    //console.log("WHAT IS THIS? " + this.$store.state.user_level);
    this.refreshMenu();
    // 메뉴 레드닷 — 진입 시 1회 조회
    if (this.$store.state.user_level) this.loadReviewCounts();
    // 검수/금교환 처리 완료 시 각 화면이 emit → 레드닷 즉시 재조회 (갱신 안 되던 문제 해결)
    this.$root.$on('menu-dot:refresh', this.loadReviewCounts);
    //this.getServer();
    const storedData = JSON.parse(localStorage.getItem('selected_package'));
    if(storedData != null)
      this.selected_game = storedData;
    
    // store.state.selected_game_package = this.selected_game;
    // store.state.selected_game_server = this.selected_server;
    
    
    let fullPath = this.$route.fullPath;
    if(fullPath == '/')
    {//이럴꺼면 그냥 대시보드를 보여준다 
      this.$router.push('/dashboard');
    }

  },
    watch :{
            '$store.state.user_level': function() {
         this.refreshMenu();
         // 로그인/권한 확정 시점에 미검수 건수 조회
         if (this.$store.state.user_level) this.loadReviewCounts();
            //itemContainer
        },
        // '$store.state.selected_game_package': function() {
        //     // 데이터 저장
        //     localStorage.setItem('selected_package', JSON.stringify(store.state.selected_game_package));
        //     //alert("Package : " + store.state.selected_game_package);
        //     // 데이터 불러오기
        //     //const storedData = JSON.parse(localStorage.getItem('key'));
        //     store.state.selected_game_server = 1;
        //     this.getgames();
        // }
        
    }
  
};
</script>

<style>
/* ========== 미검수 리뷰 레드닷 ========== */
.review-red-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #ff3b30;
  margin-left: 6px;
  vertical-align: middle;
  box-shadow: 0 0 0 2px rgba(255, 59, 48, 0.25);
  animation: review-dot-pulse 1.6s ease-in-out infinite;
}
@keyframes review-dot-pulse {
  0%, 100% { box-shadow: 0 0 0 2px rgba(255, 59, 48, 0.25); }
  50%      { box-shadow: 0 0 0 4px rgba(255, 59, 48, 0.10); }
}

/* ========== 헤더 ========== */
.cms-appbar {
  z-index: 6 !important;
}
.cms-appbar__title {
  font-weight: 700;
  font-size: 17px;
  letter-spacing: 0.5px;
}

/* ========== 사이드바 ========== */
.cms-sidebar {
  background: #FAFAFA !important;
  border-right: 1px solid #E0E0E0 !important;
}
.cms-sidebar__profile {
  display: flex;
  align-items: center;
  padding: 14px 16px;
}
.cms-sidebar__profile-info {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.cms-sidebar__profile-name {
  font-size: 14px;
  font-weight: 600;
  color: #212121;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.cms-sidebar__profile-env {
  margin-top: 2px;
}

/* 메뉴 */
.cms-sidebar__menu {
  padding: 4px 8px !important;
}
.cms-sidebar__group-title {
  font-size: 13px !important;
  font-weight: 700 !important;
  color: #424242 !important;
  letter-spacing: 0.3px;
}
.cms-sidebar__item {
  min-height: 36px !important;
  padding: 0 8px 0 12px !important;
  margin: 1px 0 !important;
  border-radius: 6px !important;
}
.cms-sidebar__item--active {
  background: #E3F2FD !important;
}
.cms-sidebar__item--active .cms-sidebar__item-title {
  color: #1565C0 !important;
  font-weight: 600 !important;
}
.cms-sidebar__item--active .v-icon {
  color: #1565C0 !important;
}
.cms-sidebar__item-icon {
  margin-right: 8px !important;
  min-width: 28px !important;
}
.cms-sidebar__item-title {
  font-size: 13px !important;
  color: #616161 !important;
}
.cms-sidebar__divider {
  padding: 4px 16px;
}
.cms-sidebar__divider-label {
  text-align: center;
  font-size: 11px;
  color: #BDBDBD;
  letter-spacing: 2px;
  padding: 2px 0;
}
.cms-sidebar__select-wrap {
  padding: 4px 16px;
}
.cms-sidebar__select {
  font-size: 13px;
}

/* 그룹 아이콘/화살표 작게 */
.cms-sidebar__group .v-list-group__header {
  min-height: 40px !important;
  padding: 0 8px !important;
}

/* ========== 컨텐츠 영역 ========== */
.cms-content {
  background: #F5F5F5 !important;
}

/* ========== 글로벌 컴포넌트 스타일 개선 ========== */

/* 툴바 통일 */
.v-toolbar {
  border-radius: 0 !important;
}
.v-toolbar__title {
  font-size: 16px !important;
  font-weight: 600 !important;
  letter-spacing: 0.3px;
}

/* 카드 세련되게 */
.v-card {
  border-radius: 8px !important;
  box-shadow: 0 1px 4px rgba(0,0,0,0.08) !important;
}
.v-card > .v-toolbar:first-child,
.v-card > .v-overlay:first-child + .v-toolbar {
  border-radius: 8px 8px 0 0 !important;
}

/* 데이터테이블 개선 */
.v-data-table {
  font-size: 13px !important;
}
.v-data-table th {
  font-size: 12px !important;
  font-weight: 700 !important;
  color: #546E7A !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  background: #FAFAFA !important;
  border-bottom: 2px solid #E0E0E0 !important;
  white-space: nowrap;
}
.v-data-table td {
  font-size: 13px !important;
  padding: 8px 16px !important;
  border-bottom: 1px solid #F0F0F0 !important;
}
.v-data-table tbody tr:hover {
  background: #F5F9FF !important;
}

/* 다이얼로그 세련되게 */
.v-dialog > .v-card {
  border-radius: 12px !important;
  box-shadow: 0 8px 32px rgba(0,0,0,0.15) !important;
}
.v-dialog > .v-card > .v-card__title {
  font-size: 18px !important;
  font-weight: 700 !important;
  padding: 20px 24px 12px !important;
}

/* 버튼 둥글게 */
.v-btn {
  border-radius: 6px !important;
  text-transform: none !important;
  letter-spacing: 0.2px !important;
  font-weight: 600 !important;
}
.v-btn--fab {
  border-radius: 50% !important;
}
.v-btn--icon {
  border-radius: 50% !important;
}
.v-btn--round {
  border-radius: 28px !important;
}

/* 칩 */
.v-chip {
  font-weight: 600 !important;
}

/* 텍스트필드 */
.v-text-field--outlined fieldset {
  border-color: #E0E0E0 !important;
}
.v-text-field--outlined:hover fieldset {
  border-color: #90CAF9 !important;
}

/* 탭 세련되게 */
.v-tabs .v-tab {
  text-transform: none !important;
  font-weight: 600 !important;
  letter-spacing: 0.2px;
  font-size: 14px !important;
}

/* v-list-item 호버 */
.v-list-item:hover {
  background: rgba(0,0,0,0.03);
}

/* v-select 드롭다운 */
.v-select__selections {
  font-size: 13px !important;
}

/* ========== 환경별 색상 구분 ========== */

/* CSS 변수 정의 */
.env-live {
  --cms-toolbar-bg: #37474F;
  --cms-toolbar-gradient: linear-gradient(135deg, #37474F 0%, #455A64 50%, #546E7A 100%);
}
.env-dev {
  --cms-toolbar-bg: #1565C0;
  --cms-toolbar-gradient: linear-gradient(135deg, #0D47A1 0%, #1565C0 50%, #1976D2 100%);
}

/* 라이브: 상단에 빨간 액센트, 툴바 진한 회색 유지 */
.env-live .cms-appbar {
  border-top: 3px solid #F44336 !important;
}
.env-live .v-content .theme--dark.v-toolbar:not(.cms-toolbar--alert):not(.toolbar-custom) {
  background-color: #37474F !important;
}

/* 개발/로컬: 상단에 파란 액센트, 툴바 파란색 */
.env-dev .cms-appbar {
  border-top: 3px solid #2196F3 !important;
}
.env-dev .v-content .theme--dark.v-toolbar:not(.cms-toolbar--alert):not(.toolbar-custom) {
  background-color: #1565C0 !important;
}

/* 메일 전체발송 경고 툴바 (항상 빨간색) */
.v-content .cms-toolbar--alert.theme--dark.v-toolbar {
  background-color: #C62828 !important;
}

/* ========== 모바일 하단 네비바 가림 방지 ========== */
@media (max-width: 600px) {
  .cms-content {
    padding-bottom: env(safe-area-inset-bottom, 20px) !important;
  }
  .cms-content > .v-content__wrap {
    padding-bottom: 16px !important;
  }
  .cms-appbar__title {
    font-size: 15px;
  }
  .v-data-table th,
  .v-data-table td {
    padding: 6px 10px !important;
    font-size: 12px !important;
  }
}
</style>